import { Route, Switch } from "wouter";
import { Layout } from "./components/Layout";
import AccessAdmin from "./pages/AccessAdmin";
import Advertising from "./pages/Advertising";
import Alerts from "./pages/Alerts";
import ArchivedAlerts from "./pages/ArchivedAlerts";
import Changelog from "./pages/Changelog";
import CompanySettings from "./pages/CompanySettings";
import Designs from "./pages/Designs";
import DeveloperManualViewer from "./pages/DeveloperManualViewer";
import Home from "./pages/Home";
import Inventory from "./pages/Inventory";
import InvoiceDetail from "./pages/InvoiceDetail";
import InvoiceNew from "./pages/InvoiceNew";
import Invoices from "./pages/Invoices";
import ListingImport from "./pages/ListingImport";
import Login from "./pages/Login";
import Manual from "./pages/Manual";
import Marketplaces from "./pages/Marketplaces";
import NotFound from "./pages/NotFound";
import RequestAccess from "./pages/RequestAccess";
import Sales from "./pages/Sales";
import StockoutAudit from "./pages/StockoutAudit";

export default function App() {
  return (
    <Layout>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/login" component={Login} />
        <Route path="/request-access" component={RequestAccess} />
        <Route path="/admin/access" component={AccessAdmin} />
        <Route path="/admin/settings" component={CompanySettings} />
        <Route path="/alerts/audit" component={StockoutAudit} />
        <Route path="/alerts/archived" component={ArchivedAlerts} />
        <Route path="/alerts" component={Alerts} />
        <Route path="/import" component={ListingImport} />
        <Route path="/inventory" component={Inventory} />
        <Route path="/marketplaces" component={Marketplaces} />
        <Route path="/sales" component={Sales} />
        <Route path="/advertising" component={Advertising} />
        <Route path="/designs" component={Designs} />
        <Route path="/invoices/new" component={InvoiceNew} />
        <Route path="/invoices/:id" component={InvoiceDetail} />
        <Route path="/invoices" component={Invoices} />
        <Route path="/manual" component={Manual} />
        <Route path="/manual/:slug" component={Manual} />
        <Route path="/changelog" component={Changelog} />
        <Route path="/developer-manual" component={DeveloperManualViewer} />
        <Route component={NotFound} />
      </Switch>
    </Layout>
  );
}
